import React, { FC, ReactElement } from "react";

import {
  Box,
  Flex,
  Text,
  Button,
  ModalProps,
  SystemStyleObject,
} from "@chakra-ui/react";

import NewModal from "../NewModal";

interface IModalProps extends Pick<
  ModalProps,
  "isOpen" | "onClose" | "onEsc" | "onOverlayClick"
> {
  title: ReactElement | string;
  modalBody: ReactElement;
  modalFooter?: ReactElement;
  dismissible?: boolean;
  size?:
    | "full"
    | "large" // Slightly smaller than full screen (100vh - 24px)
    | "xs"
    | "sm"
    | "md"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "4xl"
    | "5xl"
    | "6xl";
  subtitle?: string;
  borderRadius?: string;
  bodyStyle?: SystemStyleObject;
  headerStyle?: SystemStyleObject;
}
interface IConfirmModalProps extends Pick<IModalProps, "onClose" | "isOpen"> {
  onConfirm: () => void;
  isLoading: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: string;
  cancelVariant?: string;
  confirmButtonFirst?: boolean;
  modalContentStyle?: SystemStyleObject;
}

const ConfirmModal: FC<IConfirmModalProps> = ({
  onClose,
  isOpen,
  title = "Are you sure?",
  isLoading,
  onConfirm,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmVariant = "primary",
  cancelVariant = "outline",
  confirmButtonFirst = true,
  modalContentStyle,
}) => {
  return (
    <NewModal
      title={title}
      modalBody={
        <Box>
          <Text as="p" color="brand.gray.500">
            {message}
          </Text>
          <Flex
            width="100%"
            alignItems="center"
            mt="6"
            gap="2"
            flexDirection={confirmButtonFirst ? "row" : "row-reverse"}
          >
            <Button
              isLoading={isLoading}
              isDisabled={isLoading}
              onClick={onConfirm}
              variant={confirmVariant}
              width="100%"
            >
              {confirmLabel}
            </Button>
            <Button onClick={onClose} variant={cancelVariant} width="100%">
              {cancelLabel}
            </Button>
          </Flex>
        </Box>
      }
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      modalContentStyle={modalContentStyle}
    />
  );
};

export default ConfirmModal;
